import React, { useEffect, useState } from "react";
import DashboardHeader from "@/components/dashboard/DashboardHeader";
import MetricsGrid from "@/components/dashboard/MetricsGrid";
import RecentActivity from "@/components/dashboard/RecentActivity";
import QuickActions from "@/components/dashboard/QuickActions";
import InsightsSection from "@/components/dashboard/InsightsSection";
import { ProjectsList } from "@/components/dashboard/ProjectsList";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import MainLayout from '@/components/layout/MainLayout';
import { EnhancedDashboardAI } from "@/components/ai/EnhancedDashboardAI";

const Index = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setIsAuthenticated(!!session);
      
      // Don't redirect here - let PrivateRoute handle redirects
      // This prevents circular redirects between / and /auth
    };

    checkAuth();

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        setIsAuthenticated(!!session);
        // Don't redirect here - let PrivateRoute handle redirects
      }
    );

    return () => subscription.unsubscribe();
  }, [navigate]);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
        <p className="mt-2 text-sm text-muted-foreground">Loading dashboard...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <MainLayout>
      <DashboardHeader />
      
      <div className="space-y-6">
        <QuickActions />
        <EnhancedDashboardAI />
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main content - spans 2 columns on large screens */}
          <div className="lg:col-span-2 space-y-8">
            <MetricsGrid />
            <RecentActivity />
            <InsightsSection />
          </div>
          
          {/* Sidebar-like column */}
          <div className="space-y-8">
            <ProjectsList />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Index;
